export function makeUrl(imageServiceBaseUrls, fileId, fileName, width, height, mode) {
  const baseUrl = imageServiceBaseUrls[fileId % imageServiceBaseUrls.length]
  const encodedFileName = encodeURIComponent(fileName)
  return `${baseUrl}/${fileId}-${width}x${height}${mode}-${encodedFileName}`
}
